export default function teamsFilter() {
    // Находим все элементы фильтров и колонок
    const teamFilters = document.querySelectorAll('.js-team-filter');
    const teamCols = document.querySelectorAll('.js-team-col');

    // Добавляем обработчики кликов на фильтры
    teamFilters.forEach(filter => {
        filter.addEventListener('click', () => {
            // Получаем data-атрибут фильтра
            const filterValue = filter.getAttribute('data-teams-filter');
            
            // Удаляем класс active у всех фильтров и колонок
            teamFilters.forEach(f => f.classList.remove('active'));
            teamCols.forEach(col => col.classList.remove('active'));
            
            // Добавляем класс active только выбранному фильтру
            filter.classList.add('active');
            
            // Находим соответствующую колонку и добавляем ей класс active
            const targetCol = document.querySelector(`.js-team-col[data-teams-filter="${filterValue}"]`);
            if (targetCol) {
                targetCol.classList.add('active');
            }
        });
    });
}